import React from 'react';

export default function Solutions() {
  return (
    <main className="container solutions">
      <h2 className="title">What We Build</h2>
      <p className="intro">
        NOVIONIX Labs engineers intelligence in motion-systems that anticipate, adapt, and act as the world unfolds.
      </p>

      <section>
        <h3 className="section-title">⚙️ Core Constructs</h3>
        <ul className="list">
          <li className="item">
            <strong>Temporal Dynamics Engine</strong><br />
            Continuous forecasting architecture that evolves with unfolding events far beyond static models.
          </li>
          <li className="item">
            <strong>Cognitive Agent Framework</strong><br />
            Autonomous decision-makers that reason and respond in real time, without manual tuning.
          </li>
          <li className="item">
            <strong>Heuristic Inference Core</strong><br />
            A synergistic blend of memory, pattern recognition, and symbolic inference.
          </li>
          <li className="item">
            <strong>Synthetic Reality Labs</strong><br />
            High-fidelity simulations to stress-test agents across time, causality, and uncertainty.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="section-title">🧠 Flagship Platforms</h3>
        <ul className="list">

          <li className="item">
            <a
              href="https://aether-sports.web.app/dashboard"
              target="_blank"
              rel="noopener noreferrer"
              className="product-link"
            >
              Aether Sports
            </a>
            <p className="item-desc">
              real-time strategic intelligence for live sports betitng. 'Vegas runs the house. We run the code.'
            </p>
          </li>


          <li className="item">
            <a
              href=""
              target="_blank"
              rel="noopener noreferrer"
              className="product-link"
            >
              Lucen OS
            </a>
            <p className="item-desc">
              A living behavioral OS that grows with its user, tracking context and meaning.
            </p>
          </li>
          
        </ul>
      </section>
    </main>
  );
}
